import {Link} from "react-router-dom";

const CreateBookButton = () => {
    return (
        <div className="ml-4">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Not The Book You Wanted?
            </h3>
            <Link to="/createBook">
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                    Create A Book
                </button>
            </Link>
        </div>
    )
}

export default CreateBookButton
